@if (loading()) {
<p class="auth-lead" aria-live="polite">Cargando tu invitación…</p>
} @else if (notFound()) {
<h1 class="auth-title">Esta invitación no existe</h1>
<p class="auth-lead">Revisa que el enlace esté completo o pide uno nuevo a quien te invitó.</p>
<p class="switch-line"><a routerLink="/auth/signin" class="link">Ir a iniciar sesión</a></p>
} @else if (accepted(); as done) {
<h1 class="auth-title">Ya eres parte de {{ done.businessName }}</h1>
<p class="auth-lead">
  Tu cuenta está lista. Entras como <strong>{{ done.roleName }}</strong> con tu correo {{ done.email }}.
  Te enviamos un correo de bienvenida.
</p>
<div class="actions">
  <button type="button" class="btn-primary" (click)="goToSignIn()">Iniciar sesión</button>
</div>
} @else if (invitation(); as inv) {
  @if (inv.status !== 'pending') {
  <h1 class="auth-title">
    {{ inv.status === 'accepted' ? 'Ya usaste esta invitación' : inv.status === 'expired' ? 'Esta invitación venció' : 'Esta invitación fue cancelada' }}
  </h1>
  <p class="auth-lead">
    @if (inv.status === 'accepted') {
    Tu cuenta en {{ inv.businessName }} ya existe. Entra con tu correo {{ inv.email }}.
    } @else {
    Pide a {{ inv.businessName }} que te envíe una nueva.
    }
  </p>
  <p class="switch-line"><a routerLink="/auth/signin" class="link">Ir a iniciar sesión</a></p>
  } @else {
  <div class="invite-business">
    @if (inv.businessLogoUrl) {
    <img [src]="inv.businessLogoUrl" alt="" class="invite-logo" />
    } @else {
    <span class="invite-logo invite-logo--initial" [style.background]="inv.businessPrimaryColor || null">
      {{ inv.businessName[0] }}
    </span>
    }
    <span class="invite-role">{{ inv.roleName }}</span>
  </div>
  <h1 class="auth-title">Únete a {{ inv.businessName }}</h1>
  <p class="auth-lead">
    Te invitaron como <strong>{{ inv.roleName }}</strong>.
    @if (inv.isProfessional) { Vas a ver tu agenda y tus citas. }
    Completa tus datos y crea tu contraseña.
  </p>

  <form class="form-start" [formGroup]="form" (ngSubmit)="submit()" novalidate>
    <div class="fields">
      <div class="invite-email">
        <span class="field-label">Tu correo para entrar</span>
        <p>{{ inv.email }}</p>
      </div>

      <div class="invite-names">
        <div>
          <label class="field-label" for="inv-first">Nombre</label>
          <input id="inv-first" class="input" formControlName="firstName" autocomplete="given-name"
            [class.is-invalid]="showError('firstName')" [attr.aria-invalid]="showError('firstName')" />
          @if (showError('firstName')) { <p class="field-error">Escribe tu nombre.</p> }
        </div>
        <div>
          <label class="field-label" for="inv-last">Apellido</label>
          <input id="inv-last" class="input" formControlName="lastName" autocomplete="family-name"
            [class.is-invalid]="showError('lastName')" [attr.aria-invalid]="showError('lastName')" />
          @if (showError('lastName')) { <p class="field-error">Escribe tu apellido.</p> }
        </div>
      </div>

      <div>
        <label class="field-label" for="inv-phone">Celular</label>
        <app-phone-input formControlName="phone" id="inv-phone"></app-phone-input>
        @if (showError('phone')) { <p class="field-error">Escribe tu celular.</p> }
      </div>

      <div>
        <label class="field-label" for="inv-password">Crea tu contraseña</label>
        <div class="input-wrap">
          <input [type]="showPassword ? 'text' : 'password'" id="inv-password" class="input" formControlName="password"
            autocomplete="new-password" aria-describedby="inv-password-hint"
            [class.is-invalid]="showError('password')" [attr.aria-invalid]="showError('password')" />
          <button type="button" class="toggle-pass" (click)="showPassword = !showPassword"
            [attr.aria-label]="showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'" [attr.aria-pressed]="showPassword">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
              @if (showPassword) {
              <path d="M3 3l14 14M8.2 8.3a2.5 2.5 0 0 0 3.5 3.5M6 5.6C4.3 6.7 3.1 8.3 2.5 10c1.2 3.3 4.2 5.5 7.5 5.5 1.4 0 2.8-.4 4-1.1M9 4.6c.3 0 .7-.1 1-.1 3.3 0 6.3 2.2 7.5 5.5-.4 1-.9 1.9-1.6 2.7"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
              } @else {
              <path d="M2.5 10c1.2-3.3 4.2-5.5 7.5-5.5s6.3 2.2 7.5 5.5c-1.2 3.3-4.2 5.5-7.5 5.5S3.7 13.3 2.5 10Z"
                stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" />
              <circle cx="10" cy="10" r="2.5" stroke="currentColor" stroke-width="1.5" />
              }
            </svg>
          </button>
        </div>
        <p [class]="showError('password') ? 'field-error' : 'field-hint'" id="inv-password-hint">
          Al menos 8 caracteres, con una mayúscula, una minúscula, un número y un símbolo.
        </p>
      </div>

      <div>
        <label class="field-label" for="inv-confirm">Repite la contraseña</label>
        <input [type]="showPassword ? 'text' : 'password'" id="inv-confirm" class="input" formControlName="confirmPassword"
          autocomplete="new-password" [class.is-invalid]="mismatch" [attr.aria-invalid]="mismatch" />
        @if (mismatch) { <p class="field-error">Las dos contraseñas deben ser iguales.</p> }
      </div>
    </div>

    @if (error()) {
    <p class="field-error invite-error" role="alert">{{ error() }}</p>
    }

    <div class="actions">
      <button type="submit" class="btn-primary" [disabled]="submitting()">
        @if (submitting()) {
        <span class="spinner" aria-hidden="true"></span>
        Creando tu cuenta…
        } @else {
        Crear mi cuenta
        }
      </button>
    </div>
  </form>

  <p class="switch-line invite-expiry">La invitación vence el {{ inv.expiresAt | date: "d 'de' MMMM" }}.</p>
  }
}
